import { useEffect, useState } from 'react'
import { supa, backendReady } from '../net/supa'
import { load, save } from '../lib/storage'
import { Icon } from './Icon'

/* A one-line notice from the admin console across the top of every page. */
export function Announcement() {
  const [a, setA] = useState<{ id: number; body: string; tone: string } | null>(null)
  const [gone, setGone] = useState<number[]>(() => load('annGone', []))
  useEffect(() => {
    if (!backendReady) return
    supa.from('announcements').select('id,body,tone').order('created_at', { ascending: false }).limit(1).then(({ data }) => {
      if (data && data[0]) setA(data[0] as { id: number; body: string; tone: string })
    })
  }, [])
  if (!a || gone.includes(a.id)) return null
  const close = () => {
    const next = [...gone, a.id].slice(-20)
    setGone(next)
    save('annGone', next)
  }
  return (
    <div className={`announce tone-${a.tone}`} role="status">
      <span>{a.body}</span>
      <button onClick={close} aria-label="Dismiss"><Icon id="i-x" /></button>
    </div>
  )
}
